import type { Company } from '../api/types';
import { t } from '../i18n/messages';
import styles from './SiteFooter.module.css';

export function SiteFooter({ company }: { company: Company }) {

  return (
    <footer className={styles.footer}>
      <div className={`shell ${styles.inner}`}>
        <p>
          © {new Date().getFullYear()} {company.legalName} · {t.footer.registryCode}{' '}
          {company.registryCode}
        </p>
        <p className={styles.spacer}>
          <a href={`tel:${company.phoneHref}`}>{company.phone}</a>
        </p>
        <p>
          <a href="#top">{t.footer.backToTop}</a>
        </p>
      </div>
    </footer>
  );
}
